import React from "react";
import { Box } from "@mui/material";
import ListCellName from "./ListCellName";
import ListCellOrg from "./ListCellOrg";

const ListViewName = ({ users, removable, type, onDelete, icon_name, onSetConducteur, folderData, orgData }) => {
  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "8px",
        borderColor: "rgba(0, 0, 0, 0.12)",
        borderWidth: "1.5px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0)",
        overflow: "auto",
      }}
    >
      {/* Conditional rendering based on the users array */}
      {users === null ||
      users.length === 0 ||
      (users.length === 1 && !users[0]) ? (
        <div className="text-h3 text-shadow_50">Pas de personne assigné</div>
      ) : type == "user" ? (
        users.map((user, index) => (
          <div key={index}>
            <ListCellName
              key={user?.id}
              user={user}
              removable={removable}
              onDelete={onDelete}
              icon_name={icon_name}
              onSetConducteur={onSetConducteur}
              folderData={folderData}
              orgData={orgData}
            />
          </div>
        ))
      ) : (
        users.map((org, index) => (
          <div key={index}>
            <ListCellOrg
              key={org?.id}
              org={org}
              removable={removable}
              onDelete={onDelete}
              icon_name={icon_name}
            />
          </div>
        ))
      )}
    </Box>
  );
};

export default ListViewName;
